import { Button, Col, Input, Row } from "antd";
import { SearchOutlined, ClearOutlined } from "@ant-design/icons";
import { debounce } from "lodash";

export function VideoFilter({ filter, onFilterChange }) {
  const handleSearch = debounce((key, value) => {
    const newFilter = { ...filter, [key]: value };
    onFilterChange(newFilter);
  }, 300);

  const handleClear = () => {
    onFilterChange({});
  };

  return (
    <Row gutter={16} style={{ marginBottom: 16 }}>
      <Col span={12}>
        <Input
          placeholder="Tìm kiếm tiêu đề hoặc video ID..."
          onChange={(e) => handleSearch("search", e.target.value)}
          prefix={<SearchOutlined />}
          size="large"
        />
      </Col>
      <Col span={12}>
        <Button icon={<ClearOutlined />} onClick={handleClear} size="large">
          Xóa bộ lọc
        </Button>
      </Col>
    </Row>
  );
}
